import { OperatorModel } from "./operator.model";
export class Community2Model {
    communityId?:number;
    communityName?:string;
    description?:string;
    communityType?:string;
    generationTime?:Date;
     }
   